require("./AlternativeFundBox.scss");

const React = require("react");
const PropTypes = require("prop-types");
const { connect } = require("react-redux");
const { formatText } = require("core/i18n").i18n;
const RiskIndicator = require("../../components/RiskIndicator");
const { getTrailingPerformance } = require("../../selectors/fundDataSelectors");

// @utilites
const {
    formatAmount,
    getPlainAmountObject,
    formatWithoutRound,
} = require("utilities/currencyHelper");
// @commons
const OKTooltip = require("components/commons/OKTooltip/OKTooltip");

class AlternativeFundBox extends React.Component {
    buildTooltip(tooltipContent) {
        if (tooltipContent) {
            return (
                <OKTooltip
                    content={tooltipContent}
                    placement="right"
                    offset={[10, 0]}
                />
            );
        }
    }

    render() {
        const { fund, catalogueDetails } = this.props;

        const getUnits = (number) => {
            if (number == null) {
                return 2;
            }
            return Number.isInteger(parseFloat(number))
                ? 2
                : number.toString().split(".")[1].length;
        };

        const managementFeeExDistFeeActual = fund.hasOwnProperty("mifid")
            ? fund.mifid.managementFeeExDistFeeActual
            : fund.mgmtFeeExAnte;
        const units = getUnits(managementFeeExDistFeeActual);
        const maxDecimals = units <= 1 ? 2 : units >= 4 ? 3 : units;

        const riskIndicatorSection = (
            <div>
                <section className="info--riskIndicator">
                    <RiskIndicator
                        riskValue={Number(catalogueDetails.risk[0])}
                        regulatoryTextKeyArray={[]}
                        isAlternativeFund={true}
                    />
                </section>
                <hr className="info--divider" />
            </div>
        );

        const tooltip = (content) => this.buildTooltip(content);

        return (
            <div>
                <section className="info--account">
                    <h1 className="info--title">
                        {catalogueDetails && catalogueDetails.name}
                    </h1>
                    {formatText("brokerAlternativeFundsCard-isin")}: &nbsp;
                    {catalogueDetails.isin}
                </section>
                {riskIndicatorSection}
                <section>
                    <ul className="list-inline">
                        <li className="list-inline-item info--assetType">
                            {formatText("brokerAlternativeFundsCard-assetType")}
                            <div className="assetType--value">
                                {formatText(
                                    `brokerAlternativeFundsCard-assetTypeValue_inversionAlternativa`
                                )}
                            </div>
                        </li>
                        <li className="list-inline-item info--assetSubtype">
                            {formatText(
                                "brokerAlternativeFundsCard-assetSubtype"
                            )}
                            <div className="assetSubtype--value">
                                {formatText(
                                    `brokerAlternativeFundsCard-assetSubTypeValue_${catalogueDetails.subAssetClass}`
                                )}
                            </div>
                        </li>
                        <li className="list-inline-item info--minInvestment">
                            {formatText(
                                "brokerAlternativeFundsCard-minInvestment"
                            )}
                            <div className="minInvestment--value">
                                {catalogueDetails.minInvestment ? (
                                    <span>
                                        <span className="current--boldValue">
                                            {formatAmount(
                                                catalogueDetails.minInvestment
                                            )}
                                            &nbsp;
                                        </span>
                                        <span className="current--bold">
                                            {getPlainAmountObject(
                                                catalogueDetails.currency
                                            )}
                                            &nbsp;
                                        </span>
                                    </span>
                                ) : (
                                    "-"
                                )}
                            </div>
                        </li>
                    </ul>
                </section>
                <section>
                    <ul className="list-inline">
                        <li className="list-inline-item info--suscription">
                            {formatText(
                                "brokerAlternativeFundsCard-suscription"
                            )}
                            {tooltip(
                                formatText(
                                    "brokerAlternativeFundsCard-suscription_tooltip"
                                )
                            )}
                            <div className="suscription--value">
                                {catalogueDetails.subsPeriod ? (
                                    <div className="type--value">
                                        {
                                            <span>
                                                {formatText(
                                                    `brokerAlternativeFundsCard-suscription_${catalogueDetails.subsPeriod}`
                                                )}
                                            </span>
                                        }
                                    </div>
                                ) : (
                                    "-"
                                )}
                            </div>
                        </li>
                        <li className="list-inline-item info--refund">
                            {formatText("brokerAlternativeFundsCard-refund")}
                            {tooltip(
                                formatText(
                                    "brokerAlternativeFundsCard-refund_tooltip"
                                )
                            )}
                            <div className="refund--value">
                                {catalogueDetails.redempPeriod ? (
                                    <div className="refund--value">
                                        {
                                            <span>
                                                {formatText(
                                                    `brokerAlternativeFundsCard-refund_${catalogueDetails.redempPeriod}`
                                                )}
                                            </span>
                                        }
                                    </div>
                                ) : (
                                    "-"
                                )}
                            </div>
                        </li>
                        <li className="list-inline-item info--permanency">
                            {formatText(
                                "brokerAlternativeFundsCard-permanency"
                            )}
                            {tooltip(
                                formatText(
                                    "brokerAlternativeFundsCard-permanency_tooltip"
                                )
                            )}
                            <div className="permanency--value">
                                {catalogueDetails.lockUp && (
                                    <div className="type--value">
                                        {catalogueDetails.lockUp ? (
                                            <span>
                                                {catalogueDetails.lockUp}
                                                {catalogueDetails.lockUp == 1
                                                    ? formatText(
                                                          "brokerAlternativeFundsCard-permanencyPeriodYear"
                                                      )
                                                    : formatText(
                                                          "brokerAlternativeFundsCard-permanencyPeriodYears"
                                                      )}
                                            </span>
                                        ) : (
                                            "-"
                                        )}
                                    </div>
                                )}
                            </div>
                        </li>
                    </ul>
                </section>
                <p className="list-inline info__gestor">
                    {formatText("brokerAlternativeFundsCard-administrator")}
                    {catalogueDetails.provider ? (
                        <span>{catalogueDetails.provider}</span>
                    ) : (
                        "-"
                    )}
                </p>
                <section className="info__details">
                    <div className="closePrice__value">
                        <p className="value--title">
                            {formatText(
                                "brokerAlternativeFundsCard-closePrice"
                            )}
                        </p>
                        <p className="value--current">
                            <span>
                                <span className="current--boldValue">
                                    {fund.closePrice && fund.closePrice.value
                                        ? formatAmount(fund.closePrice.value)
                                        : "-"}
                                    &nbsp;
                                </span>
                                <span className="current--bold">
                                    {fund.closePrice &&
                                        fund.closePrice.value &&
                                        getPlainAmountObject(
                                            fund.closePrice.currency
                                        )}
                                    &nbsp;
                                </span>
                            </span>
                        </p>
                    </div>
                    <div className="details__periodicityVL">
                        <p className="periodicityVL--title">
                            {formatText(
                                "brokerAlternativeFundsCard-periodicityVL"
                            )}
                        </p>
                        <p className="periodicityVL--current">
                            <span className="current--bold">
                                {catalogueDetails.navFrequency
                                    ? formatText(
                                          `brokerAlternativeFundsCard-periodicityVL_${catalogueDetails.navFrequency}`
                                      )
                                    : "-"}
                            </span>
                        </p>
                    </div>
                    <div className="details__irr">
                        <p className="irr--title">
                            {formatText("brokerAlternativeFundsCard-irr")}
                            {tooltip(
                                formatText(
                                    "brokerAlternativeFundsCard-irr_tooltip"
                                )
                            )}
                        </p>
                        <p className="irr--current">
                            <span className="current--bold">
                                {catalogueDetails.irr
                                    ? formatWithoutRound(
                                          catalogueDetails.irr,
                                          maxDecimals
                                      ) + "%"
                                    : "-"}
                            </span>
                        </p>
                    </div>
                    <div className="details__managementFees">
                        <p className="managementFees--title">
                            {formatText(
                                "brokerAlternativeFundsCard-managementFees"
                            )}
                        </p>
                        <p className="managementFees--current">
                            <span className="current--bold">
                                {managementFeeExDistFeeActual
                                    ? formatWithoutRound(
                                          managementFeeExDistFeeActual,
                                          maxDecimals
                                      )
                                    : "-"}
                                {"%"}
                            </span>
                        </p>
                    </div>
                </section>
            </div>
        );
    }
}

AlternativeFundBox.propTypes = {
    fund: PropTypes.object.isRequired,
    trailingPerformance: PropTypes.object.isRequired,
    catalogueDetails: PropTypes.object.isRequired,
};

const mapStateToProps = (state, props) => ({
    trailingPerformance: getTrailingPerformance(state, props),
});

module.exports = connect(mapStateToProps)(AlternativeFundBox);
